import { render, staticRenderFns } from "./shareFolderMore.vue?vue&type=template&id=04912782&scoped=true"
import script from "./shareFolderMore.vue?vue&type=script&lang=js"
export * from "./shareFolderMore.vue?vue&type=script&lang=js"
import style0 from "./shareFolderMore.vue?vue&type=style&index=0&id=04912782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04912782",
  null
  
)

export default component.exports